export default "__VITE_ASSET__D0oS1m3u__"